import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function KnowledgeBaseIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_5015_10894)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.1279 3.49162C14.9709 3.00112 14.6384 2.58587 14.194 2.32554C13.4699 1.80065 12.6013 1.51232 11.7071 1.5C10.3564 1.58412 9.06374 2.07921 8.00246 2.9189L7.91474 2.81054C6.94315 1.97929 5.71057 1.51547 4.432 1.5C3.42443 1.50064 2.43741 1.78495 1.58388 2.32038C1.38103 2.45697 1.20758 2.63281 1.07377 2.83751C0.939962 3.04221 0.8485 3.27164 0.80478 3.51225C0.139188 3.67736 -0.00012207 4.07981 -0.00012207 5.00339V12.4952C0.0329366 12.9434 0.241877 13.3604 0.581136 13.6552C0.920394 13.95 1.36245 14.0987 1.81091 14.0688H6.86734C6.94777 14.237 7.07445 14.3787 7.23255 14.4774C7.39064 14.5761 7.57359 14.6277 7.75996 14.6261H8.24496C8.43132 14.6277 8.61428 14.5761 8.77237 14.4774C8.93046 14.3787 9.05715 14.237 9.13758 14.0688H14.194C14.6416 14.0973 15.0823 13.9479 15.4205 13.6533C15.7586 13.3586 15.9668 12.9424 15.9999 12.4952V5.00339C15.9947 4.04886 15.8606 3.64124 15.1279 3.49162ZM2.7448 12.2062C1.47037 12.619 1.42393 12.5106 1.42393 11.2104V4.13141C1.41155 3.91904 1.46226 3.70775 1.56968 3.52413C1.6771 3.34051 1.83642 3.19277 2.02761 3.09948C4.18949 1.68575 6.5784 2.71767 7.58453 3.55353V12.6242L7.4865 12.5829C5.97988 11.9689 4.57647 11.6129 2.74996 12.2062H2.7448ZM13.2446 12.2062C11.542 11.4013 9.38524 12.2062 8.5339 12.5829C8.48603 12.6054 8.43586 12.6227 8.38427 12.6345V3.56385C9.27689 2.8931 11.382 1.5 13.9154 3.08916C14.1138 3.17646 14.281 3.32176 14.3952 3.50595C14.5094 3.69015 14.5652 3.9046 14.5552 4.12109V11.4994C14.5655 12.4848 14.5603 12.8202 13.2498 12.2062H13.2446Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5015_10894",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  });
}
KnowledgeBaseIcon.displayName = 'KnowledgeBaseIcon';